import React from "react";

const CoursePoints = ({ course }) => {
  return (
    <div className="course-container-points">
      <div 
        className="course-points-title"
        dangerouslySetInnerHTML={{ __html: course.courseNameShort }}
      ></div>
      <div className="course-points-count">{course.progress}</div>
    </div>
  );
};

export default CoursePoints;
